import AbstractValueRowTemplate from "./AbstractValueRowTemplate.js";

/**
 * Abstract superclass of rows that contain accounts.
 *
 * @abstract
 * @param {boolean} [spec.creditPositive=false] - Whether the row's values should be positive when credit
 */
export default class AbstractAccountRowTemplate extends AbstractValueRowTemplate {
	constructor({ creditPositive = false } = {}) {
		super(...arguments);
		this._creditPositive = creditPositive;
	}

	isCreditPositive() {
		return (
			(this.getParent().isRow() && this.getParent().isCreditPositive()) ||
			this._creditPositive
		);
	}

	setCreditPositive(value) {
		this._creditPositive = value;
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);

		spec.creditPositive = this._creditPositive;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.creditPositive = this._creditPositive;

		return properties;
	}
}
